export default "__VITE_ASSET__CrwvW0ZC__"